import { z } from 'zod';
import { coerceNumber } from '../../validation';
import { allJoinReasons } from '../../data/joinReasons';

const labelOf = (id: number) =>
  allJoinReasons.find((reason) => reason.id === id)?.value;

// The reason a member joins, as its numeric id — the stable API contract of the
// join reason list (see data/joinReasons). The referral forms send the id of the
// option chosen, which a select carries as text, so the numeric string is
// accepted as the number it is.
//
// Declared as the SET of ids rather than as a number with a check on it, so the
// ids reach the OpenAPI page as an `enum` a partner can read instead of a bare
// "number" (a check is a rule no JSON Schema can express). The labels go with
// them: the ids are the contract and mean nothing on their own.
export const joinReasonIdSchema = (ids: number[]) =>
  coerceNumber(
    z
      .literal(ids, {
        // One message per mistake: `z.literal(ids, message)` would report the
        // same one for an id left out and an id outside the set (the reason
        // `requiredEnum` exists).
        error: (issue) =>
          issue.input === undefined
            ? 'Join reason ID is required'
            : `Join reason ID must be one of the following values: ${ids.join(
                ', ',
              )}`,
      })
      .meta({
        description: `The reason the member joins: ${ids
          .map((id) => `${id} = ${labelOf(id) ?? 'unknown'}`)
          .join(', ')}.`,
      }),
  );
